export default "__VITE_ASSET__CTE2w9yW__"